var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-select",
    {
      attrs: { disabled: _vm.disabled },
      model: {
        value: _vm.index,
        callback: function ($$v) {
          _vm.index = $$v
        },
        expression: "index",
      },
    },
    _vm._l(_vm.indexList, function (item) {
      return _c("yxt-option", {
        key: item,
        attrs: { label: item, value: item },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }